export const getStepNumber = (sectionName: string, isInIframe?: boolean) => {
  switch (sectionName) {
    case 'prerequisites':
      return '01'
    case 'accountConfiguration':
      return '02'
    case 'cloudCredentials':
      return isInIframe ? '02' : '03'
  }
}
